// API service for referral system

const API_BASE = ''; // Same origin

export interface ReferralData {
  referral_code: string;
  referral_count: number;
  is_premium: boolean;
  premium_until?: string;
}

export const fetchReferralData = async (telegramId: number): Promise<ReferralData | null> => {
  try {
    const response = await fetch(`${API_BASE}/api/referral/${telegramId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch referral data');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching referral data:', error);
    return null;
  }
};

export const applyReferralCode = async (
  telegramId: number,
  referralCode: string
): Promise<{ success: boolean; error?: string }> => {
  try {
    const response = await fetch(`${API_BASE}/api/referral/apply`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ telegram_id: telegramId, referral_code: referralCode }),
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to apply referral code');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error applying referral code:', error);
    return { success: false, error: String(error) };
  }
};

export const generateReferralCode = (telegramId: number): string => {
  // Generate a unique code based on telegram ID
  const base = telegramId.toString(36).toUpperCase();
  const random = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `${base}${random}`;
};

